import SubMenu from 'common/navigation/components/sub-menu';
import MainMenu from 'common/navigation/containers/main-menu-container';
import Wrapper from 'common/navigation/wrapper';
import PropTypes from 'prop-types';
import React from 'react';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { withRouter } from 'utils/withRouter';
import { ticketObjectRoutes } from '../common/navigation/routes/cops-routes';
import TicketWorklistContainer from '../tickets/containers/list/ticket-worklist-container';
import { referenceTypes } from '../utils/app-configs';
import Dashboard from './dashboard/components/dashboard';
import Info from './info/containers/installed-at-info-container';
import Timeline from './timeline/components/timeline';

const InstalledAt = ({ match }) => {
  const id = match.params.installedAtId;
  const renderMenu = actionButtons =>
    <MainMenu id={id} type={referenceTypes.installedAt} actionButtons={actionButtons}>
      <SubMenu
        id={id}
        baseType={referenceTypes.installedAt}
        base={`installedat/${id}`}
        hasTickets={true}
        extraLinks={
          [
            {
              translationKey: 'nav.subNav.TIMELINE',
              uri: `/installedat/${id}/timeline`,
              absolute: true,
            },
          ]
        }
      />
    </MainMenu>;
  const ticketRoutes = ticketObjectRoutes();
  return (
    <Wrapper>
      <Routes>
        <Route
          path={'dashboard/*'}
          element={<Dashboard id={id} renderMenu={renderMenu} />}
        />
        <Route
          path={'info/:timestamp?'}
          element={<Info id={id} renderMenu={renderMenu} />}
        />
        <Route
          path={'timeline/:jumpToDateOrFilter?/:filtervalue?'}
          element={
            <Timeline
              id={id}
              renderMenu={renderMenu}
            />
          }
        />
        {ticketRoutes?.map((r, i) => <Route
          path={`${r}/*`}
          key={i}
          element={
            <TicketWorklistContainer
              renderMenu={renderMenu}
              baseType={referenceTypes.installedAt}
            />
          }
        />)}
        <Route
          path='/*'
          element={<Navigate to='dashboard' replace />}
        />
      </Routes>
      <Outlet />
    </Wrapper>
  );
};

InstalledAt.propTypes = {
  match: PropTypes.object.isRequired,
};

export default withRouter(InstalledAt);
